export default __webpack_public_path__ + "static/PEPEBANKSY-cc4621fa66dca7222ea5ce89b8fa28ae.jpg";